import { useStyletron } from '@olxeu-jobs/ui';
import { forwardRef } from 'react';
import { OfficeWithTrees } from '~ui/illustrations';
import { useFormatMessage } from '~i18n';
import { ResponsiveLogoImage, Wrapper, MAX_WIDTH } from './styled-components';

type Props = React.ComponentProps<'div'> & {
  url: string | undefined | null;
  companyName?: string | null;
  className?: string;
};

export const Logo = forwardRef<HTMLDivElement, Props>(({ url, companyName, ...props }, ref) => {
  const [css] = useStyletron();
  const formatMessage = useFormatMessage();
  const alt = companyName
    ? (formatMessage(
        {
          id: 'comp.alt.company_logo',
          defaultMessage: '{company_name} logo',
        },
        { company_name: companyName },
      ) as string)
    : '';

  return (
    <Wrapper ref={ref} {...props}>
      {!url ? (
        <OfficeWithTrees alt="" data-testid="default-logo" className={css({ height: '100%' })} />
      ) : (
        <ResponsiveLogoImage
          src={url}
          assetWidths={MAX_WIDTH}
          params={{ format: 'webp', quality: 90 }}
          alt={alt}
          data-testid="logo"
        />
      )}
    </Wrapper>
  );
});
